// Mirror of backend/twilio_service/message_types.py. Form reminders and
// appointment confirmations share the scheduled_messages table; any list
// meant for one of them must step around the other's rows.
export const CONFIRMATION_FPATH = "appointment_confirmation";
export const CONFIRMATION_MESSAGE_TYPES = ["confirmation", "auto_confirmation"];

export const isConfirmationScheduledRow = (row) => {
  if (!row || typeof row !== "object") return false;
  if (CONFIRMATION_MESSAGE_TYPES.includes(row.message_type)) return true;
  const payload = row.payload && typeof row.payload === "object" ? row.payload : row;
  return (
    payload.fpath === CONFIRMATION_FPATH ||
    CONFIRMATION_MESSAGE_TYPES.includes(payload.source)
  );
};
